<template>
  <div class="museum-form">
    <form v-on:submit.prevent>
      <div class="field is-flex">
        <div class="control is-clearfix">
          <input
            type="search"
            id="searchTerm"
            class="input"
            v-model="query.term"
            placeholder="Type search terms"
          />
        </div>
        <SearchQuery
          :searchText="searchButtonTitle"
          :index="esIndex"
          :query="esQuery"
          :from="fromValue"
          :size="sizeValue"
          :term="query.term"
          :searched="searched"
          :page="page"
          v-on:start:search="validateSearch"
        />
      </div>
    </form>
    <div class="musuem-categories">
      <h2>
        Current Categories
        <span
          v-if="
            Object.keys(filters).length === 0 ||
              (this.filters.gradeChecked.length > 0 ||
                this.filters.subjectChecked.length > 0 ||
                this.filters.typeChecked.length > 0 ||
                this.filters.locationChecked.length > 0)
          "
          @click="clearTags"
          >Clear tags</span
        >
      </h2>
      <div class="filter-container">
        <div v-for="item in filters.gradeChecked" :key="item.id">
          <div v-for="items in filterTerms.grade" :key="items.id">
            <span class="filter" v-if="item === items.id"
              >{{ items.name }}
              <span v-on:click="clearTag(items.id)"
                ><b-icon class="is-right" icon="close-circle"/></span
            ></span>
          </div>
        </div>
        <div v-for="item in filters.subjectChecked" :key="item.id">
          <div v-for="items in filterTerms.subject" :key="items.id">
            <span class="filter" v-if="item === items.id"
              >{{ items.name }}
              <span v-on:click="clearTag(items.id)"
                ><b-icon class="is-right" icon="close-circle"/></span
            ></span>
          </div>
        </div>
        <div v-for="item in filters.typeChecked" :key="item.id">
          <div v-for="items in filterTerms.type" :key="items.id">
            <span class="filter" v-if="item === items.id"
              >{{ items.name }}
              <span v-on:click="clearTag(items.id)"
                ><b-icon class="is-right" icon="close-circle"/></span
            ></span>
          </div>
        </div>
        <div v-for="item in filters.locationChecked" :key="item.id">
          <div v-for="items in filterTerms.location" :key="items.id">
            <span class="filter" v-if="item === items.id"
              >{{ items.name }}
              <span v-on:click="clearTag(items.id)"
                ><b-icon class="is-right" icon="close-circle"/></span
            ></span>
          </div>
        </div>
      </div>
    </div>
    <b-message
      title="Warning"
      class="warning"
      v-if="triggeredTerm"
      type="is-warning"
    >
      {{ this.badTermWarningMesssage }}
    </b-message>
  </div>
</template>

<script>
import SearchQuery from "@/components/SearchQuery";
import naughtyStrings from "@/assets/blns.json";

export default {
  name: "SearchMusEdForm",
  inject: ["runtimeConfig"],
  data() {
    return {
      index: {},
      searchButtonTitle: "Search",
      esIndex: this.runtimeConfig.elasticsearch.index,
      esQuery: {},
      searched: false,
      fromValue: 0,
      sizeValue: 10,
      startResults: 1,
      endResults: 10,
      currentPage: 1,
      query: {
        term: "",
        results: {},
        hits: [],
        totals: 0,
        pages: 1,
        suggestions: [],
        related: {}
      },
      tempArray: [],
      tempFilter: "",
      flatGrades: "",
      flatTypes: "",
      flatSubjects: "",
      flatLocation: "",
      badTerms: naughtyStrings,
      triggeredTerm: false,
      badTermWarningMesssage:
        "Sorry, this is a restricted query, please try again."
    };
  },
  props: {
    filters: Object,
    filterTerms: Object,
    searching: Boolean,
    term: String,
    page: Number
  },
  watch: {
    term(val) {
      this.query.term = val;
      this.setQuery();
    },
    searching() {
      this.setQuery();
    },
    page() {
      this.pageUpdated();
    }
  },
  components: {
    SearchQuery
  },
  methods: {
    setQuery() {
      this.flatGrades = this.filters.gradeChecked.filter(Boolean).join(",");
      this.flatTypes = this.filters.typeChecked.filter(Boolean).join(",");
      this.flatSubjects = this.filters.subjectChecked.filter(Boolean).join(",");
      this.flatLocation = this.filters.locationChecked
        .filter(Boolean)
        .join(",");

      this.esQuery = {
        bool: {
          must: [],
          filter: [
            {
              bool: {
                should: [
                  {
                    bool: {
                      should: [
                        {
                          match_phrase: {
                            url:
                              "www.getty.edu/education/teachers/classroom_resources/curricula"
                          }
                        }
                      ],
                      minimum_should_match: 1
                    }
                  }
                ]
              }
            },
            {
              bool: {
                filter: [
                  {
                    bool: {
                      should: [
                        {
                          multi_match: {
                            query: this.query.term,
                            type: "best_fields",
                            operator: "and",
                            cutoff_frequency: "0.001",
                            tie_breaker: "0.3",
                            zero_terms_query: "all"
                          }
                        }
                      ]
                    }
                  },
                  {
                    bool: {
                      should: [
                        {
                          match: {
                            "metatag.grades": {
                              query: this.flatGrades,
                              operator: "or",
                              zero_terms_query: "all"
                            }
                          }
                        }
                      ]
                    }
                  },
                  {
                    bool: {
                      should: [
                        {
                          match: {
                            "metatag.subjects": {
                              query: this.flatSubjects,
                              operator: "or",
                              zero_terms_query: "all"
                            }
                          }
                        }
                      ]
                    }
                  },
                  {
                    bool: {
                      should: [
                        {
                          match: {
                            TYPE: {
                              query: this.flatTypes,
                              operator: "or",
                              zero_terms_query: "all"
                            }
                          }
                        }
                      ]
                    }
                  },
                  {
                    bool: {
                      should: [
                        {
                          match: {
                            "metatag.location": {
                              query: this.flatLocation,
                              operator: "or",
                              zero_terms_query: "all"
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          ],
          should: [],
          must_not: []
        }
      };
    },
    search() {
      if (this.triggeredTerm === false) {
        this.searched = true;
        this.setQuery();
      }
    },
    validateSearch() {
      if (this.badTerms.includes(this.query.term)) {
        this.triggeredTerm = true;
      } else {
        this.triggeredTerm = false;
      }
      this.search();
    },
    clearTag(id) {
      this.$emit("update:cleartag", id);
    },
    clearTags() {
      this.$emit("update:cleartags");
    },
    pageUpdated() {
      this.$emit("update:page");
      if (this.currentPage < this.page) {
        this.nextPage();
      } else {
        this.prevPage();
      }
    },
    nextPage() {
      this.$emit(
        "next",
        ((this.currentPage += 1), (this.fromValue += this.sizeValue))
      );
    },
    prevPage() {
      this.$emit(
        "prev",
        ((this.currentPage -= 1), (this.fromValue -= this.sizeValue))
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.mdi-close-circle {
  color: #ababab;
}
.control {
  width: 85%;
  padding-right: 1em;
}
.search-button {
  margin: 0 1em;
}
.museum-form {
  background: #f5f5f5;
  padding: 1em;
  height: auto;
}
.musuem-categories {
  h2 {
    font-weight: 700;
    span {
      color: darken(blue, 5%);
    }
  }
  .filter-container {
    text-align: left;
    div {
      display: inline;
    }
    .filter {
      background: #d7d7d7;
      margin: 0.15em;
      padding: 0 0.25em;
      display: inline-block;
      span {
        vertical-align: text-bottom;
      }
    }
  }
}
</style>
